export default function GameWrapper({ children }) {
  return (
    <main className="w-full max-w-4xl mx-auto sm:px-4 pt-24 pb-28 flex flex-col items-center gap-6">
      {children}
    </main>
  );
}
